<script>
	import { onMount } from 'svelte'
  import { map, clamp } from '../../../util/math'

	export let className = ''
	export let color = 'black'
	export let top = false
	export let left = false
	export let velocity = 0

	let width

	onMount(() => {
		const mapVelo = map(velocity, 0, 300, 12, 28)
		width = clamp(mapVelo, 10, 28)
	})
</script>

<svg
	class={className}
	style={`
		color: ${color};
		stroke-width: ${width};
		${top ? 'top:' + top + 'px;' : ''}
		${left ? 'left:' + left + 'px;' : ''}
	`}
	width="500"
	height="500"
	viewBox="0 0 500 500"
	fill="none"
>
	<g>
	  <circle cx="250" cy="250" r="236.5" stroke="black"/>
	  <path d="M346.589 346.589C299.464 393.715 245.77 424.627 197.469 436.871C148.918 449.178 107.832 442.293 82.7695 417.231C57.7073 392.168 50.8219 351.082 63.1292 302.531C75.3731 254.23 106.285 200.536 153.411 153.411C200.536 106.285 254.23 75.3731 302.532 63.1291C351.083 50.8219 392.168 57.7073 417.231 82.7695C442.293 107.832 449.178 148.918 436.871 197.469C424.627 245.77 393.715 299.464 346.589 346.589Z" stroke="black"/>
	  <path d="M219.031 280.969C171.172 233.109 132.338 185.735 108.197 147.989C96.0797 129.043 87.9809 113.01 84.1378 100.849C82.2121 94.7549 81.5355 90.1857 81.6494 87.0053C81.7607 83.8976 82.5676 82.9714 82.7695 82.7695C82.9715 82.5675 83.8976 81.7607 87.0053 81.6494C90.1858 81.5355 94.7549 82.2121 100.849 84.1378C113.01 87.9809 129.043 96.0797 147.989 108.197C185.735 132.338 233.109 171.172 280.969 219.031C328.828 266.891 367.662 314.265 391.803 352.011C403.92 370.957 412.019 386.99 415.862 399.151C417.788 405.245 418.465 409.814 418.351 412.995C418.239 416.102 417.432 417.029 417.231 417.231C417.029 417.432 416.102 418.239 412.995 418.351C409.814 418.465 405.245 417.788 399.151 415.862C386.99 412.019 370.957 403.92 352.011 391.803C314.265 367.662 266.891 328.828 219.031 280.969Z" stroke="black"/>
	  <path d="M15.2073 484.793L484.793 15.2073" stroke="black"/>
	</g>
</svg>

<style>
	svg {
		width: 5rem;
		height: 5rem;
		position: fixed;
		color: blue;
		transform: translate(-50%, -50%);
	}
	svg.logo {
		top: 2rem;
		left: 2rem;
	}
	circle,
	path {
		stroke: currentColor;
		stroke-width: inherit;
	}
	@media screen and (min-width: 768px) {
		svg {
			width: 10rem;
			height: 10rem;
		}
	}
</style>
